import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { setPrevVentilatorState } from '../../../options/store/options.actions'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getVentilatorSelector } from '../selectors'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setPreviousVentilatorState() {
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (!pcrID) {
    // todo: add to audit log
    return
  }
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.ventilatorStateList && pcrDoc.patient?.ventilatorStateList.length) {
    const filteredVentilatorItems: Array<IVentilatorState> = [...pcrDoc.patient.ventilatorStateList].sort(
      (item1, item2) => {
        const dateTime1 = `${item1.date} ${item1.time}`
        const dateTime2 = `${item2.date} ${item2.time}`
        return +new Date(dateTime1) - +new Date(dateTime2)
      }
    )
    const index = filteredVentilatorItems?.findIndex((ventilator) => ventilator.key === ventilatorState.key)
    let previousVentilator: IVentilatorState
    if (index !== -1) {
      const prevIndex = index - 1
      previousVentilator = filteredVentilatorItems[prevIndex]
    } else {
      previousVentilator = filteredVentilatorItems[filteredVentilatorItems.length - 1]
    }
    try {
      yield put(setPrevVentilatorState(previousVentilator))
    } catch (e) {
      yield put(throwPcrException(`setPreviousVentilatorState() error: ${e}`))
    }
  }
}
export function* setPreviousVentilatorStateSaga() {
  yield takeLatest(
    [
      VentilatorConstants.SET_ACTION,
      VentilatorConstants.GET_PREVIOUS_VENTILATOR_STATE,
      VentilatorConstants.SAVE_VENTILATOR,
    ],
    performWithMutexHOG,
    setPreviousVentilatorState
  )
}
